//swiper
import Swiper from 'swiper/bundle'

function tabSlider() {
  $('.tab-slider').each((index, $tabSlider) => {
    const $btn = $tabSlider.querySelectorAll('.tab-slider__btn')
    //*
    const $swiper = $tabSlider.querySelector('.swiper-tab')
    if ($swiper.swiper) $swiper.swiper.destroy()
    //*
    const slider = createSwiper($swiper)

    //* если на мобиле, завершаем скрипт
    if (window.screen.width < 768) {
      $($btn).off('click')
      return
    }

    let activeBtn
    $($btn).each((index, $btn) => {
      if (index === 0) {
        $($btn).addClass('tab-slider__btn--active')
        activeBtn = $btn
      }
      $($btn).on('click', () => {
        if (activeBtn !== $btn) {
          $($btn).addClass('tab-slider__btn--active')
          $(activeBtn).removeClass('tab-slider__btn--active')
          activeBtn = $btn
          slider.slideTo(index)
        }
      })
    })
  })
}

document.addEventListener('DOMContentLoaded', tabSlider)
//* перезапускаем функцию при изменение ширины.
$(window).on('resize:width', tabSlider)

function createSwiper($swiper) {
  //* для пк и планшетов другой слайдер
  if (window.screen.width >= 768) {
    return new Swiper($swiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      simulateTouch: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    })
  } else {
    return new Swiper($swiper, {
      slidesPerView: 1.19,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
      },
      //navigation: {
      //  nextEl: '.swiper-navigation-next',
      //  prevEl: '.swiper-navigation-prev',
      //},
    })
  }
}
